import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Global from "../../util/Global";
import { useTranslation } from "react-i18next";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import AdsEditComponent from "../../components/Ads/AdsEditComponent";
import NotFound from "../../components/NotFound";




const EditAnnonce = ({ isAdmin }) => {
  const { id } = useParams();
  const [isLoading, setisLoading] = useState(true)
  const { showAlert } = useContext(AlertContext)
  const [adsResponseData, setadsResponseData] = useState()
  const { t } = useTranslation()
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)


  const ADS_DETAILS_URL = Global.backend + "/index.php/showAnnonce";


  useEffect(() => {
    if (isAdmin) {
      setnavLinks([{ path: "/dashboard/admin/annonces-admin", label: t("adsList") }, { path: "/dashboard/admin/adminannoncedetails/" + id, label: "adsDetails" }])
      setpageNavLink({ path: "/dashboard/admin", label: t("adminDashboard") })
    } else {
      setnavLinks([{ path: "/dashboard/user/mesannonces", label: t("adsList") }, { path: "/dashboard/user/monannonce/" + id, label: "adsDetails" }])
      setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    }

    setpageTitle("editAd")
    setalertTitle("")
  }, [])




  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.post(ADS_DETAILS_URL, { userId:localStorage.getItem("id"),annonceId: id })
    ]).then(axios.spread((adsResponse) => {
      setadsResponseData(adsResponse.data);
    }))
      .catch((err) => {
        showAlert("error", t("request.errorFetchAdDetails"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);








  return (
    <LoaderComponent isLoading={isLoading}>
      {!adsResponseData ? <NotFound /> : <AdsEditComponent adsResponseData={adsResponseData} />}
    </LoaderComponent>
  )
};

export default EditAnnonce;